const NOTIFICATION_CATEGORY_ERROR = 'error';
const NOTIFICATION_CATEGORY_DEFAULT = 'default';

export default {
  error: NOTIFICATION_CATEGORY_ERROR,
  default: NOTIFICATION_CATEGORY_DEFAULT,
};
